import { useSyncExternalStore } from "react";

import {
  isBrowsing,
  setBrowsing,
  subscribeBrowsing,
} from "../common/auth/browseMode";

/**
 * Whether this visitor chose to look around without an account.
 *
 * `useSyncExternalStore` because the flag lives outside React (it has to
 * survive a reload and be readable by the router before any component
 * mounts), and every consumer must see the same answer in the same render.
 */
export default function useBrowseMode() {
  const browsing = useSyncExternalStore(
    subscribeBrowsing,
    isBrowsing,
    () => false
  );

  return {
    browsing,
    startBrowsing: () => setBrowsing(true),
    stopBrowsing: () => setBrowsing(false),
  };
}
